import React, {memo} from 'react';
import UseRailScrollEvent from "../../common/hooks/useScrollEvent";
import styled from "styled-components";
import VenatusAd from "./VenatusAd";


const SmallRail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  margin-bottom: 15px;
  max-height: 250px;
`;


const LeftSideWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 600px;
`;



const RightSIdeStickyBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const StickyBoxWrapper = styled.div`
  min-width: 300px;
  padding-top: 20px;
  position: relative;
  margin-left: 1px;
`;
const RightRailAd = () => {
    const ref = UseRailScrollEvent();

    return <VenatusAd placementName={'vertical_sticky'}/>
    // return (
    //     <StickyBoxWrapper>
    //         <RightSIdeStickyBox ref={ref}>
    //             <SmallRail data-ad={'right-rail-1'}>
    //                 <VenatusAd placementName={'vertical_sticky'}/>
    //             </SmallRail>
    //             <LeftSideWrapper  data-ad={'right-rail-2'}>
    //                 <VenatusAd placementName={'vertical_sticky'}/>
    //             </LeftSideWrapper>
    //         </RightSIdeStickyBox>
    //     </StickyBoxWrapper>
    // )
}

export default memo(RightRailAd);